import { render, staticRenderFns } from "./SurveysChart.vue?vue&type=template&id=4e6d4048&"
import script from "./SurveysChart.vue?vue&type=script&lang=ts&"
export * from "./SurveysChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports